export default {
  'add-to-cart': 'Ajouter au panier',
  'out-stock': 'Épuisé',
  'delete-from-cart': 'Supprimer du panier',
  'updated-attributes-product': 'Informations sur le produit mises à jour',
};
